import { jsx } from "react/jsx-runtime";
import PostalCodeInputWUT from "../../../ui/address-input/postal-code-input-wut.js";
import JapanPostalCodeMarkWUT from "./japan-postal-code-mark-wut.js";
import { TextInputFieldWUT } from "../../../ui/text-input-field/text-input-field-wut.js";
const JapanPostalCodeWUT = ({
  autocomplete,
  ...props
}) => {
  const prefix = /* @__PURE__ */ jsx(JapanPostalCodeMarkWUT, {});
  return autocomplete ? /* @__PURE__ */ jsx(PostalCodeInputWUT, { ...props, prefix }) : /* @__PURE__ */ jsx(TextInputFieldWUT, { ...props, prefix });
};
export {
  JapanPostalCodeWUT as default
};
//# sourceMappingURL=japan-postal-code-wut.js.map
